var ehib = ehib || {};
( function () {
    'use strict';
    jQuery( function () {
        ehib.init();
    } );

    ehib.init = function () {
        ehib.customSearchBar.init();
        ehib.events.init();
        ehib.members();
    };
    ehib.customSearchBar = {};
    ehib.customSearchBar.init = function () {
        jQuery( '.js-custom-search-form' ).on( 'submit', function ( e ) {
            e.preventDefault();
            var customSearchBarValue = jQuery( this ).find( '.custom-search-input' ).val();
            jQuery( '.js-e-search .js-e-search-input' ).val( customSearchBarValue ).trigger( 'input' );
            jQuery( '.js-e-search' ).trigger( 'shown.bs.modal' );
        } );
        jQuery( '.js-trigger-search' ).on( 'click', function ( e ) {
            e.preventDefault();
            jQuery( '.js-custom-search-form' ).trigger( 'submit' );
        } );
    };
    ehib.members = function () {
        var xmlListContainer = jQuery( '.js-render-members-from-xml' );
        if ( xmlListContainer.length === 1 ) {
            xmlListContainer.append( '<ul class="list-group list-group-flush" />' );
            jQuery.ajax( {
                    url: '/Files/Files/Medlemmer/medlemmer.xml',
                    type: 'GET',
                    dataType: 'xml'
                } )
                .done( function ( xml ) {
                    var result = jQuery( xml ).find( 'result' ),
                        sortedResult = result.find( 'Companies_116' ).sort( function ( a, b ) {
                            var strA = jQuery(a).attr('Kaldenavn_Virksomheder') || jQuery(a).attr('Firmanavn_Virksomheder'),
                                strB = jQuery(b).attr('Kaldenavn_Virksomheder') || jQuery(b).attr('Firmanavn_Virksomheder'),
                                d, e, f;

                            function getIntArray( c ) {
                                var array = [];
                                c = c.toLowerCase();
                                for ( var i = 0; i < c.length; i++ ) {
                                    if ( c.substring( i, 2 ) == 'aa' ) {
                                        array.push( 300 );
                                        i++;
                                    }
                                    else {
                                        switch ( c.charCodeAt( i ) ) {
                                        case 229: //å
                                            array.push( 299 );
                                            break;
                                        case 248: //ø
                                            array.push( 298 );
                                            break;
                                        case 230: //æ
                                            array.push( 297 );
                                            break;
                                        default:
                                            array.push( c.charCodeAt( i ) );
                                            break;
                                        }
                                    }
                                }
                                return array;
                            }
                            d = getIntArray( strA );
                            e = getIntArray( strB );
                            for ( f = 0; f < d.length; f++ ) {
                                if ( d[ f ] != e[ f ] ) {
                                    return d[ f ] - e[ f ];
                                }
                            }

                        } );
                    xmlListContainer.hide();
                    sortedResult.each( function () {
                        var company = jQuery( this ).attr( 'Firmanavn_Virksomheder' ),
                            website = jQuery( this ).attr( 'Web_Virksomheder' ),
                            kaldenavn = jQuery( this ).attr( 'Kaldenavn_Virksomheder' );

                        // Use "kaldenavn" if it has a value, otherwise use "company"
                        var displayName = kaldenavn ? kaldenavn : company;

                        var xmlListItem = '<li class="list-group-item"><strong>' + displayName + '</strong><br><small><i class="material-icons">link</i> <a href="http://' + website + '">' + 'Gå til hjemmeside' + '</a></small></li>';
                        xmlListContainer.find( 'ul' ).append( xmlListItem );
                    } );
                    xmlListContainer.fadeIn( 'slow' );
                } );

        }
    };
    ehib.events = {
        init: function () {
            ehib.events.bindEvents();
            ehib.events.getVendor();
        },
        bindEvents: function () {
            jQuery( '.js-ehib-submit-event-attendee' ).on( 'click', 'button[type="submit"]', function ( event ) {
                if ( jQuery( '.js-ehib-submit-event-attendee' ).valid() === true ) {
                    var formid = jQuery( '.js-ehib-submit-event-attendee' ).attr( 'id' );
                    e4.data.forms.dwSpamScripts[ formid ]( jQuery( '.js-ehib-submit-event-attendee' )[ 0 ] );
                    jQuery.ajax( {
                            type: 'POST',
                            url: jQuery( '.js-ehib-submit-event-attendee' ).attr( 'action' ),
                            data: new FormData(jQuery(".js-ehib-submit-event-attendee")[0]),
                            processData: false,
                            contentType: false
                        } )
                        .done( function ( data ) {
                            ehib.events.submitAttendee( '.js-ehib-submit-event-attendee' );
                        } )
                        .fail( function ( error ) {
                            console.error( error );
                        } );
                }
                return false;
            } );

        },
        submitAttendee: function ( form ) {
            var submitGaEvent = {
                'eventCategory': 'Events',
                'eventAction': 'Eventtilmelding: ' + jQuery( '.js-event-title' ).text(),
                'eventLabel': location.href,
                'eventValue': 0,
                'eventInteraction': true,
                'event': 'track-ga-event'
            };

            e4.gtm.pushDataLayer( submitGaEvent );
            jQuery( '.js-ehib-event-confirm-modal' ).modal();
            jQuery( form ).find( '.js-ehib-submit-event-attendee-clear' ).fadeOut( 'slow', function () {
                jQuery( this ).val( '' ).fadeIn( 'fast' );
            } );
        },
        getVendor: function () {
            if ( jQuery( '.js-addeventatc' ).length ) {
                jQuery.getScript( '//addevent.com/libs/atc/1.6.1/atc.min.js', function () {
                    ehib.events.calendar();
                } );
            }
            if ( jQuery( '.js-ehib-social-share' ).length ) {
                jQuery.getScript( '//cdnjs.cloudflare.com/ajax/libs/jsSocials/1.5.0/jssocials.js', function () {
                    ehib.events.share();
                } );
            }
        },
        calendar: function () {
            jQuery( '.addeventatc' ).removeAttr( 'hidden' );
        },
        NEWWalendar: function () {
            //jQuery( '.addeventatc' ).removeAttr( 'hidden' );
            var jCal = jQuery( '.js-addeventatc' );
            var startdate = jCal.find( '.start' ).length ? new Date( jCal.find( '.start' ).text() ) : null,
                enddate = jCal.find( '.end' ).length ? new Date( jCal.find( '.end' ).text() ) : null;

            jCal.icalendar( {
                start: startdate,
                end: enddate,
                title: jCal.find( '.title' ).text(),
                description: jCal.find( '.description' ).text(),
                location: jCal.find( '.location' ).text(),
                popup: true,
                popupText: 'Tilføj til kalender'
            } );
        },
        share: function () {
            jQuery( '.js-ehib-social-share' ).jsSocials( {
                shareIn: 'popup',
                showLabel: false,
                showCount: false,
                shares: [ {
                        share: 'facebook',
                        logo: '/Files/Templates/Designs/ehib/_assets/img/svg-icons/logo_facebook_simple.svg'
                    },
                    {
                        share: 'linkedin',
                        logo: '/Files/Templates/Designs/ehib/_assets/img/svg-icons/logo_linkedin_simple.svg'
                    }
                     ]
            } );
            jQuery( '.jssocials-share-logo' ).each( function () {
                var classArr = jQuery( this ).attr( 'class' ).split( ' ' );
                jQuery( this ).text( classArr[ 1 ] );
            } );
        }
    };

}() );
